import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ title, subtitle }) => {
  return (
    <div className="left-64 w-[80%] h-[51px] bg-[#F5F6F7] font-nohemi">
      <div className="flex items-center justify-between mb-4">
        <div className="my-2">
          <div>
            <h3 className="font-semibold text-base text-[#191B1C]">{title}</h3>
            <p className="mt-2 pt-0 inline-flex text-sm font-normal text-[#626C70]">{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default Title;
